/**
 * @property {string} status - 'active|tag'
 * @returns {string} userStatus
 * @returns {string} tag
 */

export const parseUserStatus = (status) => {
  if (!status) {
    return {
      userStatus: '',
      tag: '',
    };
  }

  const [userStatus, tag] = status.split('|');
  return {
    userStatus,
    tag,
  };
};
